import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";
import { successToast, errorToast } from "../../../Utils/toast";
import { AddWhereHouse } from "../../../redux/services/WhereHouseService/wherehouse.Services";
import Swal from "sweetalert2";

function CreateWhereHouse() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    warehouseName: "",
    warehouseCode: "",
    managerName: "",
    contactNumber: "",
    address: "",
    status: 1
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.warehouseName.trim()) {
      newErrors.warehouseName = ["Warehouse Name is required"];
    }

    if (!formData.warehouseCode.trim()) {
      newErrors.warehouseCode = ["Warehouse Code is required"];
    }

    if (!formData.managerName.trim()) {
      newErrors.managerName = ["Manager Name is required"];
    }

    if (!formData.contactNumber.trim()) {
      newErrors.contactNumber = ["Mobile is required"];
    } else if (!/^\d{10}$/.test(formData.contactNumber.trim())) {
      newErrors.contactNumber = ["Please enter a valid 10-digit mobile number"];
    }

    if (!formData.address.trim()) {
      newErrors.address = ["Address is required"];
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        warehouse_name: formData.warehouseName.trim(),
        warehouse_code: formData.warehouseCode.trim(),
        manager_name: formData.managerName.trim(),
        contact_number: formData.contactNumber.trim(),
        address: formData.address.trim(),
        status: Number(formData.status)
      };
      const res = await AddWhereHouse(payload);
      if (res?.success) {
        // Show success toast with message from API
        successToast(res?.message || "Warehouse created successfully!");

        // Reset form
        setFormData({
          warehouseName: "",
          warehouseCode: "",
          managerName: "",
          contactNumber: "",
          address: "",
          status: 1
        });
        setErrors({});
     
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      } else {
        // Show error toast with message from API
        errorToast(res?.message || "Failed to create warehouse");
      }
    } catch (error) {
      console.error("Error creating warehouse:", error);
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
        errorToast("Please check the form for errors");
      } else {
        errorToast(error?.response?.data?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main_page">
          {/* HEADER */}
          {/* <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Create Warehouse</h4>
            <button
              className="add-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div> */}

          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <label>Warehouse Name <span className="text-danger">*</span></label>
              <input
                type="text"
                name="warehouseName"
                value={formData.warehouseName}
                onChange={handleChange}
                className={`form-control custumform ${errors?.warehouseName ? "is-invalid" : ""}`}
                placeholder="Enter warehouse name"
              />
              {errors?.warehouseName && (
                <div className="invalid-feedback d-block">
                  {errors.warehouseName[0]}
                </div>
              )}
            </div>

            {/* Warehouse Code */}
            <div className="col-md-6">
              <label>Warehouse Code <span className="text-danger">*</span></label>
              <input
                type="text"
                name="warehouseCode"
                value={formData.warehouseCode}
                onChange={handleChange}
                className={`form-control custumform ${errors?.warehouseCode ? "is-invalid" : ""}`}
                placeholder="Enter warehouse code"
              />
              {errors?.warehouseCode && (
                <div className="invalid-feedback d-block">
                  {errors.warehouseCode[0]}
                </div>
              )}
            </div>

            {/* Manager Name */}
            <div className="col-md-6">
              <label>Manager Name <span className="text-danger">*</span></label>
              <input
                type="text"
                name="managerName"
                value={formData.managerName}
                onChange={handleChange}
                className={`form-control custumform ${errors?.managerName ? "is-invalid" : ""}`}
                placeholder="Enter manager name"
              />
              {errors?.managerName && (
                <div className="invalid-feedback d-block">
                  {errors.managerName[0]}
                </div>
              )}
            </div>

            {/* Contact Number */}
            <div className="col-md-6">
              <label>Contact Number <span className="text-danger">*</span></label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setFormData((prev) => ({
                    ...prev,
                    contactNumber: value,
                  }));
                  if (errors.contactNumber) {
                    setErrors((prev) => ({
                      ...prev,
                      contactNumber: null,
                    }));
                  }
                }}
                className={`form-control custumform ${errors?.contactNumber ? "is-invalid" : ""}`}
                placeholder="Enter 10-digit mobile number"
                maxLength={10}
              />
              {errors?.contactNumber && (
                <div className="invalid-feedback d-block">
                  {errors.contactNumber[0]}
                </div>
              )}
            </div>

            {/* Status */}
            <div className="col-md-6">
              <label>Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>

            {/* Address */}
            <div className="col-md-12">
              <label>Address <span className="text-danger">*</span></label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows="3"
                className={`form-control custumform ${errors?.address ? "is-invalid" : ""}`}
                placeholder="Enter warehouse address"
              />
              {errors?.address && (
                <div className="invalid-feedback d-block">
                  {errors.address[0]}
                </div>
              )}
            </div>

            {/* SUBMIT */}
            <div className="col-12 text-end">
              <button
                type="submit"
                className="add-btn"
                disabled={loading}
              >
                {loading ? "Creating..." : "Create Warehouse"}
              </button>
            </div>
          </form>
        </div>
  
  );
}

export default CreateWhereHouse;